var _G, _G2, _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgWalletBase = function SvgWalletBase(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.049,
    height: 63.483,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 181.049 63.483"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#wallet-base_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#330E07",
    fillRule: "evenodd",
    d: "M31.763 10h117.523c12.019 0 21.763 9.734 21.763 21.741s-9.744 21.742-21.763 21.742H31.763C19.743 53.483 10 43.749 10 31.74 10 19.734 19.744 10 31.763 10",
    clipRule: "evenodd"
  }))), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    filter: "url(#wallet-base_svg__b)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#330E07",
    fillRule: "evenodd",
    d: "M31.763 10h117.523c12.019 0 21.763 9.734 21.763 21.741s-9.744 21.742-21.763 21.742H31.763C19.743 53.483 10 43.749 10 31.74 10 19.734 19.744 10 31.763 10",
    clipRule: "evenodd"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#wallet-base_svg__c)",
    strokeWidth: 0.871,
    d: "M31.764 10.436h117.522c11.779 0 21.328 9.539 21.328 21.305s-9.548 21.307-21.328 21.307H31.764c-11.78 0-21.328-9.54-21.328-21.307s9.548-21.306 21.328-21.306Z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "wallet-base_svg__c",
    x1: 90.525,
    x2: 90.525,
    y1: 53.483,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })))));
};
export default SvgWalletBase;